import { React, useState } from 'react';
import { signUp, confirmSignUp } from 'aws-amplify/auth';
import {
  Container,
  FormWrap,
  FormContent,
  Form,
  FormH1,
  FormLabel,
  FormInput,
  FormButton,
  Text,
  NavBtnLink,
  SignUpTermsContainer,
  Checkbox,
  CheckboxText,
  ErrorText
} from '../SignIn/SigninElements.js';

const SignUp = () => {

  const [email, setEmail] = useState('');
  const [username, setUsername] = useState('');   // <-- NEW FIELD
  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState("");
  const [termsAffirmed, setTermsAffirmed] = useState(false);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [verStatus, setVerStatus] = useState(false);
  const [confirmCode, setConfirmCode] = useState('');
  const [confirmStatus, setConfirmStatus] = useState(false);

  const handleSignUp = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    try {
      const { user } = await signUp({
        username: username,   // Cognito login username = email
        password,
        options: {
          userAttributes: {
            email: email,          // REQUIRED
            name: name,            // Standard attribute
            "custom:username": username  // <-- REQUIRED CUSTOM ATTRIBUTE
          }
        }
      });

      console.log('Sign up successful!', user);
      setError('');
      setVerStatus(true);

    } catch (error) {
      console.error('Error signing up:', error);
      setError(error.message || 'An error occurred during sign-up.');
    }
  };

  const handleSignUpConfirmation = async (e) => {
    e.preventDefault();

    try {
      await confirmSignUp({
        username: username,           // MUST match signUp username
        confirmationCode: confirmCode
      });

      setMessage('Successful Sign Up! Please Sign In');
      setConfirmStatus(true);

    } catch (error) {
      console.error('Error confirming sign-up:', error);
      setError(error.message || 'An error occurred during confirmation.');
    }
  };

  return (
    <Container>
      <FormWrap>
        <FormContent>

          {verStatus ? (
            confirmStatus ? (
              <Form>
                <Text>{message}</Text>
                <NavBtnLink to='/signin'>Sign In</NavBtnLink>
              </Form>
            ) : (
              <Form>
                <FormH1>Check Email For Confirmation Code</FormH1>
                <FormLabel>Confirmation Code</FormLabel>
                <FormInput
                  value={confirmCode}
                  onChange={e => setConfirmCode(e.target.value)}
                  required
                />
                <Text>{error}</Text>
                <FormButton type='submit' onClick={handleSignUpConfirmation}>
                  Submit
                </FormButton>
              </Form>
            )
          ) : (
            <Form>
              <FormH1>Create Account</FormH1>

              <FormLabel>Name</FormLabel>
              <FormInput
                value={name}
                onChange={e => setName(e.target.value)}
                required
              />

              <FormLabel>Email</FormLabel>
              <FormInput
                type='email'
                value={email}
                onChange={e => setEmail(e.target.value.toLowerCase())}
                required
              />

              <FormLabel>Username</FormLabel>   {/* <-- NEW FIELD */}
              <FormInput
                value={username}
                onChange={e => setUsername(e.target.value)}
                required
              />

              <FormLabel>Password</FormLabel>
              <FormInput
                type='password'
                value={password}
                onChange={e => setPassword(e.target.value)}
                required
              />

              <FormLabel>Confirm Password</FormLabel>
              <FormInput
                type='password'
                value={confirmPassword}
                onChange={e => setConfirmPassword(e.target.value)}
                required
              />

              <SignUpTermsContainer>
                <Checkbox
                  type='checkbox'
                  onChange={() => setTermsAffirmed(!termsAffirmed)}
                />
                <CheckboxText>
                  Agree to <a href='/termsofservice' target="_blank">Terms Of Service</a>
                </CheckboxText>
              </SignUpTermsContainer>

              <FormButton
                type='submit'
                disabled={!termsAffirmed}
                onClick={handleSignUp}
              >
                Sign Up
              </FormButton>

              <ErrorText>{error}</ErrorText>

              <Text>Already have an account?</Text>
              <NavBtnLink to='/signin'>Sign In</NavBtnLink>
            </Form>
          )}

        </FormContent>
      </FormWrap>
    </Container>
  );
};

export default SignUp;
